
import Component, { mixins } from "vue-class-component"
import Calculator from "../mixins/Calculator.vue"
import { Prop } from "vue-property-decorator"
import Bestellung from "@/entities/common/bestellung"

@Component
export default class BestelllungRowSofort extends mixins(Calculator) {
  @Prop() bestellung: Bestellung
}
